module.exports = __webpack_public_path__ + "img/order.8d07d39b.png";